const category = {
  title: "分类浏览",
  subtitle: "按你的需求探索不同风格的穿搭指南",
  allCategories: "全部",
  articlesCount: "篇文章",
  noArticles: "该分类暂无文章",
  relatedCategories: "相关分类",
  breadcrumbHome: "首页",
  breadcrumbCategory: "分类",
};

export default category;